import React, { useEffect } from "react";
import {
  Grid,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useEstoquesMedicamentoState } from "./context/estoques-medicamento-context";
import { useEstoquesMedicamentoController } from "./context/estoques-medicamento-controller";
import { EstoquesMedicamentoTable } from "./estoquesMedicamentoTable.component";

export function EstoquesMedicamentoPage() {
  const { estoques, estoquePagedRequest, loading, ultimaAtualizacao, error } = useEstoquesMedicamentoState();
  const { onInit, handleOnChange, listEstoques, exportEstoques } = useEstoquesMedicamentoController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listEstoques({ ...estoquePagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Estoque de Medicamentos" },
        ]}
      />
      <PageTitle>Estoque de Medicamentos</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Nome do Medicamento"
                  value={estoquePagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SearchButton onClick={() => (async () => {
                  await listEstoques(estoquePagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={4}>
                <SortDirectionSelect
                  value={estoquePagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportEstoques} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <EstoquesMedicamentoTable currentItems={estoques} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={estoques?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
